// Module
var code = "<div class=\"ui-grid-cell-contents c-link\" smart-truncate ng-bind=\"row.entity.Id\" ui-sref=\"index.customercare.customer.transactions.details({ transactionId: row.entity.Id })\"></div>\n";
// Exports
module.exports = code;